import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "One of various signal parameters involved in the perception of modulation is the modulation frequency. Below, you can use the slider to change the modulation frequency of an amplitude modulated (AM) 1 kHz tone with a modulation depth of 100%. On the top, the time signal is shown, while the bottom depicts the perceived fluctuation strenght and roughness as a function of the modulation frequency.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0208/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
